export default __webpack_public_path__ + "static/media/help3.e2d41106.svg";